import { render, staticRenderFns } from "./UserManagementView.vue?vue&type=template&id=9f2c25a0&scoped=true"
import script from "./UserManagementView.vue?vue&type=script&lang=ts"
export * from "./UserManagementView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2c25a0",
  null
  
)

export default component.exports